/**
 * 鲸鱼跃出云层动画 — 从官网 WhaleAnimation.astro 移植。
 *
 * 四条独立动画轨道（8s 周期同步）：
 * 1. whale-rise  — 鲸鱼下潜再跃出
 * 2. cloud-breathe — 主体云层呼吸伸缩
 * 3. cloud-horizon — 远处淡入的薄云
 * 4. cloud-wake — 跃起后散开的水花/尾迹
 *
 * 深色面板用浅色填充；prefers-reduced-motion 下全部停止。
 */

const WHALE =
  'M69 170C74 125 112 92 163 87C215 81 256 108 284 150C311 191 322 218 353 232C369 213 376 193 372 172C370 162 376 158 383 167C398 184 405 202 400 222C420 210 443 215 461 204C470 199 475 204 471 214C459 247 435 265 402 266C388 296 366 316 340 325C353 335 370 341 382 343C391 345 390 352 381 355C345 366 310 349 287 324C246 348 195 346 151 325C98 300 61 242 69 170ZM88 192C97 244 130 286 173 304C194 313 213 316 230 313C207 301 191 285 184 269C178 256 182 253 194 258C218 269 236 288 253 301C264 309 274 315 282 317C264 299 249 272 235 255C194 206 143 184 88 192Z'
const CLOUD =
  'M38 376C32 358 46 345 66 346C74 320 109 313 132 330C145 340 151 350 151 360C185 379 222 383 260 377C280 375 299 370 316 362C302 379 278 391 251 399C289 402 322 398 348 386C360 370 382 365 402 374C411 344 441 335 458 351C468 361 471 372 467 381C479 386 482 394 474 403C466 413 450 417 428 416H135C94 416 62 402 38 376Z'

interface Props {
  className?: string
}

export function WhaleAnimation({ className }: Props) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 520 450"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <path id="login-brand-cloud" d={CLOUD} />
      </defs>
      {/* 远处地平线云（淡入淡出） */}
      <g transform="translate(260 380)">
        <g className="login-cloud-horizon">
          <use href="#login-brand-cloud" transform="translate(-260 -380)" />
        </g>
      </g>
      {/* 鲸鱼（升降 + 旋转） */}
      <g transform="translate(260 251.5)">
        <g className="login-whale-rise">
          <path
            transform="translate(-260 -251.5)"
            fillRule="evenodd"
            d={WHALE}
          />
        </g>
      </g>
      {/* 主体云层（呼吸） */}
      <g transform="translate(260 380)">
        <g className="login-cloud-body">
          <use href="#login-brand-cloud" transform="translate(-260 -380)" />
        </g>
      </g>
      {/* 跃起尾迹 */}
      <g transform="translate(260 408)">
        <g className="login-cloud-wake">
          <use href="#login-brand-cloud" transform="translate(-260 -380)" />
        </g>
      </g>
    </svg>
  )
}
